import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { atoms } from '@fiverr-private/theme';
import { AppI18n } from '../../../../i18n';
import { useBriefCreationContext } from '../../../../context/BriefCreationContext';
import { TitleComponentProps } from '../..';

export const IdealCandidateTitle = ({ isEditing, color }: TitleComponentProps) => {
  const { enableEnhancedUx } = useBriefCreationContext();

  const translationEditingKey = enableEnhancedUx
    ? `sections.ideal_candidate.edit_title_enhanced`
    : `sections.ideal_candidate.edit_title`;

  const translationKey = isEditing ? translationEditingKey : 'sections.ideal_candidate.title';

  return (
    <Typography
      fontWeight="bold"
      className={atoms({
        whiteSpace: 'preWrap',
      })}
      {...(color && { color })}
    >
      <AppI18n k={translationKey} />
    </Typography>
  );
};
